/**
 * @fileoverview Botão de copiar com retorno: copia o texto, avisa (toast de
 * sucesso ou de falha) e deixa `copied` ligado por um instante para trocar o
 * ícone. Volta a desligar quando o texto muda (outro contato, outro número).
 */

import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";

import { copyToClipboard } from "../../utils/copyToClipboard";

const COPIED_MS = 1600;

export const useCopyFeedback = (text, { copiedMessage, failedMessage } = {}) => {
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);
  const aliveRef = useRef(true);

  useEffect(() => {
    clearTimeout(timer.current);
    setCopied(false);
  }, [text]);

  useEffect(() => {
    aliveRef.current = true;
    return () => {
      aliveRef.current = false;
      clearTimeout(timer.current);
    };
  }, []);

  const copy = useCallback(async () => {
    const ok = await copyToClipboard(text);
    if (!aliveRef.current) return ok;
    if (!ok) {
      if (failedMessage) toast.error(failedMessage);
      return false;
    }
    if (copiedMessage) toast.success(copiedMessage);
    setCopied(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setCopied(false), COPIED_MS);
    return true;
  }, [text, copiedMessage, failedMessage]);

  return { copied, copy };
};
